// src/pages/pengamatan/buah-alami/excelDownload.js
import * as XLSX from 'xlsx';
import { database } from "../../../firebase";
import { ref, get } from "firebase/database";

// Fungsi untuk memformat tanggal ke format Excel-friendly
const formatTanggalExcel = (tanggal) => {
  if (!tanggal || tanggal === '-') return '-';
  
  try {
    const [day, month, year] = tanggal.split('-');
    if (day && month && year) {
      return `${day}/${month}/${year}`; // Format: 17/10/2025
    }
  } catch (error) {
    console.error('Error formatting date:', error);
  }
  return '-';
};

// Fungsi untuk mengkonversi nilai ke number format
const convertToNumber = (value) => {
  if (!value || value === '-' || value === '' || value === null || value === undefined) return 0;
  
  // Jika sudah number, return langsung
  if (typeof value === 'number') return value;
  
  // Jika string, coba konversi ke number
  const cleanValue = value.toString().replace(/\./g, '').replace(',', '.');
  const numValue = parseFloat(cleanValue);
  return isNaN(numValue) ? 0 : numValue;
};

// FUNGSI BARU: Format luas dengan koma sebagai pemisah desimal
const formatLuas = (value) => {
  if (!value || value === '-' || value === '' || value === null || value === undefined) return '-';
  
  const numValue = convertToNumber(value);
  if (numValue === 0) return '-';
  
  // Kembalikan sebagai number, biarkan Excel yang menangani formatting
  return numValue;
};

// Konfigurasi header untuk Excel download dengan merge 3 row 
const getExcelHeaders = () => {
  return [
    // HEADER UTAMA - MERGE 3 ROW
    { key: 'Tanggal Pengamatan', label: 'Tanggal Pengamatan', width: 18, merge: 'A1:A3' },
    { key: 'Tanggal Std Forcing', label: 'Tanggal Std Forcing', width: 18, merge: 'B1:B3' },
    { key: 'Umur', label: 'Umur', width: 8, merge: 'C1:C3' },
    { key: 'Lokasi', label: 'Lokasi', width: 10, merge: 'D1:D3' },
    { key: 'Plot', label: 'Plot', width: 8, merge: 'E1:E3' },
    { key: 'Status', label: 'Status', width: 12, merge: 'F1:F3' },
    
    // HEADER BIBIT - MERGE 1 ROW UNTUK HEADER "BIBIT" DAN 2 ROW UNTUK SUB-HEADER
    { key: 'bibit_header', label: 'BIBIT', width: 20, merge: 'G1:I1' },
    { key: 'Var', label: 'Var', width: 8, merge: 'G2:G3' },
    { key: 'Kls', label: 'Kls', width: 6, merge: 'H2:H3' },
    { key: 'Jns', label: 'Jns', width: 6, merge: 'I2:I3' },
    
    // HEADER LAINNYA - MERGE 3 ROW
    { key: 'Luas', label: 'Luas', width: 8, merge: 'J1:J3' },
    { key: 'Awal Rawat', label: 'Awal Rawat', width: 12, merge: 'K1:K3' },
    { key: 'Pjp', label: 'Pjp', width: 6, merge: 'L1:L3' },
    
    // JARAK 1 CELL SETELAH PJP
    { key: 'jarak1', label: '', width: 5, merge: 'M1:M3' },
    
    // POPULASI - HEADER BARU
    { key: 'populasi_header', label: 'Populasi', width: 15, merge: 'N1:O1' },
    { key: 'Populasi Normal', label: 'Normal', width: 12, merge: 'N2:N3' },
    { key: 'Populasi Total', label: 'Total', width: 12, merge: 'O2:O3' },
    
    // JARAK 1 CELL SETELAH POPULASI (seperti M)
    { key: 'jarak2', label: '', width: 5, merge: 'P1:P3' },
    
    // FASE BUNGA ALAMI - HEADER BARU DENGAN POSISI YANG BENAR
    { key: 'fase_bunga_header', label: 'Fase Bunga Alami', width: 20, merge: 'Q1:AF1' },
    
    // ROW 2 DAN 3 UNTUK FASE BUNGA
    { key: 'Open Heart', label: 'Open Heart', width: 10, merge: 'Q2:Q2' },
    { key: 'Open Heart Value', label: '(36-37)', width: 10, merge: 'Q3:Q3' },
    { key: 'Red Bud 125', label: 'Red Bud 1.25', width: 10, merge: 'R2:R2' },
    { key: 'Red Bud 125 Value', label: '(39-40)', width: 10, merge: 'R3:R3' },
    { key: 'Red Bud 2.54', label: 'Red Bud 2.54', width: 10, merge: 'S2:S2' },
    { key: 'Red Bud 2.54 Value', label: '(42-44)', width: 10, merge: 'S3:S3' },
    { key: 'Early Cones', label: 'Early Cones', width: 10, merge: 'T2:T2' },
    { key: 'Early Cones Value', label: '(46-48)', width: 10, merge: 'T3:T3' },
    { key: 'Mid Cones', label: 'Mid Cones', width: 10, merge: 'U2:U2' },
    { key: 'Mid Cones Value', label: '(51-53)', width: 10, merge: 'U3:U3' },
    { key: 'Late Cones', label: 'Late Cones', width: 10, merge: 'V2:V2' },
    { key: 'Late Cones Value', label: '(54-56)', width: 10, merge: 'V3:V3' },
    { key: 'Early Petals', label: 'Early Petals', width: 10, merge: 'W2:W2' },
    { key: 'Early Petals Value', label: '(57-58)', width: 10, merge: 'W3:W3' },
    { key: 'Mid Petals', label: 'Mid Petals', width: 10, merge: 'X2:X2' },
    { key: 'Mid Petals Value', label: '(60-62)', width: 10, merge: 'X3:X3' },
    { key: 'Late Petals', label: 'Late Petals', width: 10, merge: 'Y2:Y2' },
    { key: 'Late Petals Value', label: '(64-65)', width: 10, merge: 'Y3:Y3' },
    { key: 'Dry Petals', label: 'Dry Petals', width: 10, merge: 'Z2:Z2' },
    { key: 'Dry Petals Value', label: '(67-72)', width: 10, merge: 'Z3:Z3' },
    { key: 'Filling Stage 1', label: 'Filling Stage 1', width: 10, merge: 'AA2:AA2' },
    { key: 'Filling Stage 1 Value', label: '(73-105)', width: 10, merge: 'AA3:AA3' },
    { key: 'Filling Stage 2', label: 'Filling Stage 2', width: 10, merge: 'AB2:AB2' },
    { key: 'Filling Stage 2 Value', label: '(106-125)', width: 10, merge: 'AB3:AB3' },
    { key: 'SC0', label: 'SC0', width: 10, merge: 'AC2:AC2' },
    { key: 'SC0 Value', label: '(126-130)', width: 10, merge: 'AC3:AC3' },
    { key: 'SC0 LD', label: 'SC0>', width: 10, merge: 'AD2:AD2' },
    { key: 'SC0 LD Value', label: '(>130)', width: 10, merge: 'AD3:AD3' },
    { key: 'Terpetik FB', label: 'Terpetik', width: 10, merge: 'AE2:AE3' },
    { key: 'Dimakan Tikus FB', label: 'Dimakan Tikus', width: 10, merge: 'AF2:AF3' },

    // STATUS TANAMAN
    { key: 'Status Tanaman', label: 'Status Tanaman', width: 10, merge: 'AG1:AJ1' },
    { key: 'Normal', label: 'Normal', width: 10, merge: 'AG2:AG3' },
    { key: 'Penyakit', label: 'Penyakit', width: 10, merge: 'AH2:AI2' },
    { key: 'Phy', label: 'Phy', width: 10, merge: 'AH3:AH3' },
    { key: 'Erw', label: 'Erw', width: 10, merge: 'AI3:AI3' },
    { key: 'Kerdil', label: 'Kerdil', width: 10, merge: 'AJ2:AJ3' },

    // BUAH ALAMI DAN LAINNYA
    { key: 'Buah Alami', label: 'Buah Alami', width: 10, merge: 'AK1:AK3' },
    { key: 'Mati', label: 'Mati', width: 10, merge: 'AL1:AL3' },
    { key: 'Total', label: 'Total', width: 10, merge: 'AM1:AM3' },
    { key: 'Spot Mati', label: 'Spot Mati', width: 10, merge: 'AN1:AN3' },

    // PINGGIRAN
    { key: 'Status Tanaman Pinggiran', label: 'Tanaman', width: 10, merge: 'AO1:AR1' },
    { key: 'Normal Pinggiran', label: 'Normal', width: 10, merge: 'AO2:AO3' },
    { key: 'Penyakit Pinggiran', label: 'Penyakit', width: 10, merge: 'AP2:AQ2' },
    { key: 'Phy Pinggiran', label: 'Phy', width: 10, merge: 'AP3:AP3' },
    { key: 'Erw Pinggiran', label: 'Erw', width: 10, merge: 'AQ3:AQ3' },
    { key: 'Kerdil Pinggiran', label: 'Kerdil', width: 10, merge: 'AR2:AR3' },

    { key: 'Buah Alami Pinggiran', label: 'Buah Alami', width: 10, merge: 'AS1:AS3' },
    { key: 'Mati Pinggiran', label: 'Mati', width: 10, merge: 'AT1:AT3' },
    { key: 'Total Pinggiran', label: 'Total', width: 10, merge: 'AU1:AU3' },
  ];
};

// Fungsi untuk menghitung lebar kolom optimal berdasarkan konten
const calculateOptimalColumnWidths = (worksheetData) => {
  if (!worksheetData || worksheetData.length === 0) return [];

  const colCount = worksheetData[0].length;
  const colWidths = new Array(colCount).fill(8); // Default minimal width

  for (let col = 0; col < colCount; col++) {
    let maxLength = 8;
    
    for (let row = 0; row < worksheetData.length; row++) {
      const cellValue = worksheetData[row][col];
      if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
        const length = String(cellValue).length + 2;
        if (length > maxLength) {
          maxLength = length;
        }
      }
    }
    
    colWidths[col] = Math.min(Math.max(maxLength, 8), 50);
  }

  return colWidths.map(width => ({ wch: width }));
};

// Fungsi untuk mendapatkan array keys (untuk mapping data)
const getHeaderKeys = () => {
  const headers = getExcelHeaders();
  return headers
    .filter(header => 
      header.key !== 'bibit_header' && 
      header.key !== 'populasi_header' && 
      header.key !== 'fase_bunga_header' &&
      !header.key.includes('Value') &&
      header.key !== 'Status Tanaman' &&
      header.key !== 'Penyakit' &&
      header.key !== 'Status Tanaman Pinggiran' &&
      header.key !== 'Penyakit Pinggiran'
    )
    .map(header => header.key);
};

// Fungsi untuk mendapatkan konfigurasi merge
const getMergeConfig = () => {
  const headers = getExcelHeaders();
  return headers
    .filter(header => header.merge)
    .map(header => {
      const [start, end] = header.merge.split(':');
      return { 
        s: { c: XLSX.utils.decode_cell(start).c, r: XLSX.utils.decode_cell(start).r },
        e: { c: XLSX.utils.decode_cell(end).c, r: XLSX.utils.decode_cell(end).r }
      };
    });
};

// Fungsi untuk memproses data bibit
const processBibitData = (bibit) => {
    if (!bibit || bibit.trim() === '') {
        return {
            varietas: 'MD2',
            kelas: 'RC',
            jenis: 'RC'
        };
    }

    const varietas = bibit.length >= 5 ? bibit.substring(2, 5) : 'MD2';
    
    let jenis = bibit.length >= 6 ? bibit.charAt(5) : 'RC';
    
    if (jenis === 'S') {
        jenis = 'SC';
    } else if (jenis === 'C') {
        jenis = 'CR';
    } else if (jenis === 'N'){
        jenis = 'NR'
    }
    
    const kelas = bibit.length >= 7 ? bibit.charAt(6) : 'RC';

    return {
        varietas,
        kelas,
        jenis
    };
};

// Fungsi untuk menghitung Tanggal Std Forcing
const calculateTanggalStdForcing = (mulaiRawat, kelasBibit) => {
    if (!mulaiRawat || !kelasBibit) return '-';
    
    try {
        let hariTambahan;
        switch (kelasBibit) {
            case 'K':
                hariTambahan = 16;
                break;
            case 'S':
                hariTambahan = 14;
                break;
            case 'B':
                hariTambahan = 12;
                break;
            case 'RC':
                hariTambahan = 8;
                break;
            default:
                hariTambahan = 8;
        }
        
        const awalRawat = new Date(mulaiRawat);
        if (isNaN(awalRawat.getTime())) return '-';
        
        const stdForcingDate = new Date(awalRawat);
        stdForcingDate.setDate(stdForcingDate.getDate() + Math.round(hariTambahan * 30.4));
        
        const day = String(stdForcingDate.getDate()).padStart(2, '0');
        const month = String(stdForcingDate.getMonth() + 1).padStart(2, '0');
        const year = stdForcingDate.getFullYear();
        
        return `${day}-${month}-${year}`;
        
    } catch (error) {
        console.error("Error calculating Tanggal Std Forcing:", error);
        return '-';
    }
};

// Fungsi untuk mengubah format tanggal dari YYYY-MM-DD ke DD-MM-YYYY
const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString || dateString === '-' || dateString.trim() === '') return '-';
    
    try {
        if (dateString.includes('-') && dateString.split('-')[0].length === 2) {
            return dateString;
        }
        
        if (dateString.includes('-') && dateString.split('-')[0].length === 4) {
            const [year, month, day] = dateString.split('-');
            return `${day}-${month}-${year}`;
        }
        
        return dateString;
    } catch (error) {
        return '-';
    }
};

// FUNGSI TANPA LOOPING: Membuat header rows secara manual
const createManualHeaderRows = () => {
  // Row 1: Header utama + BIBIT + Populasi + Fase Bunga Alami + Status Tanaman + Pinggiran
  const row1 = [
    'Tanggal Pengamatan',
    'Tanggal Std Forcing',
    'Umur',
    'Lokasi',
    'Plot',
    'Status',
    'BIBIT', '', '',
    'Luas',
    'Awal Rawat',
    'Pjp', '',
    'Populasi', '', '',
    'Fase Bunga Alami', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    'Status Tanaman', '', '', '',
    'Buah Alami',
    'Mati',
    'Total',
    'Spot Mati',
    'Tanaman', '', '', '',
    'Buah Alami',
    'Mati',
    'Total',
  ];

  // Row 2: Sub-header bibit + Populasi + Fase Bunga + Status Tanaman + Pinggiran
  const row2 = [
    '', // A2
    '', // B2
    '', // C2
    '', // D2
    '', // E2
    '', // F2
    'Var',  // G2
    'Kls',  // H2
    'Jns',  // I2
    '', // J2
    '', // K2
    '', // L2
    '', // M2 (JARAK 1)
    'Normal', // N2
    'Total',  // O2
    '', // P2 (JARAK 2)
    // Fase Bunga Alami - Row 2
    'Open Heart',    // Q2
    'Red Bud 1.25',  // R2
    'Red Bud 2.54',  // S2
    'Early Cones',   // T2
    'Mid Cones',     // U2
    'Late Cones',    // V2
    'Early Petals',  // W2
    'Mid Petals',    // X2
    'Late Petals',   // Y2
    'Dry Petals',    // Z2
    'Filling Stage 1', // AA2
    'Filling Stage 2', // AB2
    'SC0',           // AC2
    'SC0>',          // AD2
    'Terpetik',      // AE2
    'Dimakan Tikus', // AF2
    // Status Tanaman - Row 2
    'Normal',        // AG2
    'Penyakit',      // AH2 (merge AH2:AI2)
    '',              // AI2 (part of Penyakit merge)
    'Kerdil',        // AJ2
    '', // AK2 (Buah Alami)
    '', // AL2 (Mati)
    '', // AM2 (Total)
    '', // AN2 (Spot Mati)
    // Pinggiran - Row 2
    'Normal',        // AO2
    'Penyakit',      // AP2 (merge AP2:AQ2)
    '',              // AQ2 (part of Penyakit Pinggiran merge)
    'Kerdil',        // AR2
    '', // AS2 (Buah Alami Pinggiran)
    '', // AT2 (Mati Pinggiran)
    '', // AU2 (Total Pinggiran)
  ];

  // Row 3: Nilai/nomor fase bunga + Status Tanaman + Pinggiran
  const row3 = [
    '', // A3
    '', // B3
    '', // C3
    '', // D3
    '', // E3
    '', // F3
    '', // G3
    '', // H3
    '', // I3
    '', // J3
    '', // K3
    '', // L3
    '', // M3 (JARAK 1)
    '', // N3
    '', // O3
    '', // P3 (JARAK 2)
    // Fase Bunga Alami - Row 3
    '(36-37)',       // Q3
    '(39-40)',       // R3
    '(42-44)',       // S3
    '(46-48)',       // T3
    '(51-53)',       // U3
    '(54-56)',       // V3
    '(57-58)',       // W3
    '(60-62)',       // X3
    '(64-65)',       // Y3
    '(67-72)',       // Z3
    '(73-105)',      // AA3
    '(106-125)',     // AB3
    '(126-130)',     // AC3
    '(>130)',        // AD3
    '',              // AE3 (Terpetik - merge vertikal)
    '',              // AF3 (Dimakan Tikus - merge vertikal)
    // Status Tanaman - Row 3
    '',              // AG3 (Normal)
    'Phy',           // AH3
    'Erw',           // AI3
    '',              // AJ3 (Kerdil)
    '', // AK3 (Buah Alami)
    '', // AL3 (Mati)
    '', // AM3 (Total)
    '', // AN3 (Spot Mati)
    // Pinggiran - Row 3
    '',              // AO3 (Normal Pinggiran)
    'Phy',           // AP3
    'Erw',           // AQ3
    '',              // AR3 (Kerdil Pinggiran)
    '', // AS3 (Buah Alami Pinggiran)
    '', // AT3 (Mati Pinggiran)
    '', // AU3 (Total Pinggiran)
  ];

  return [row1, row2, row3];
};

// FUNGSI BARU: Menghilangkan angka di belakang titik
const removeDecimal = (value) => {
    if (value === '-' || value === '' || value === null || value === undefined) return '-';
    
    const stringValue = value.toString();
    if (stringValue.includes('.')) {
        return stringValue.split('.')[0];
    }
    return stringValue;
};

// FUNGSI BARU: Format angka dengan separator ribuan
const formatRibuan = (value) => {
    if (value === '-' || value === '' || value === null || value === undefined || isNaN(value)) return '-';
    
    const num = parseFloat(value);
    if (num === 0) return '-';
    
    return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

// FUNGSI BARU: Menghitung populasi
const calculatePopulation = (value, pjp) => {
    if (value === '-' || value === '' || value === null || value === undefined || isNaN(value)) return '-';
    
    const numValue = parseFloat(value);
    const numPjp = parseFloat(pjp) || 1;
    
    if (numValue === 0 || numPjp === 0) return '-';
    
    const result = (numValue / numPjp) * 16666.67;
    return formatRibuan(result);
};

// FUNGSI BARU: Mengambil data fase bunga dari struktur Firebase
const getFaseBungaData = (plotData) => {
    const faseBunga = plotData.data_entry?.fase_bunga || {};
    return {
        open_heart: convertToNumber(faseBunga.open_heart_fb_ba || '-'),
        red_bud_125: convertToNumber(faseBunga.red_bud_125_fb_ba || '-'),
        red_bud_254: convertToNumber(faseBunga.red_bud_254_fb_ba || '-'),
        early_cones: convertToNumber(faseBunga.early_cones_fb_ba || '-'),
        mid_cones: convertToNumber(faseBunga.mid_cones_fb_ba || '-'),
        late_cones: convertToNumber(faseBunga.late_cones_fb_ba || '-'),
        early_petals: convertToNumber(faseBunga.early_petals_fb_ba || '-'),
        mid_petals: convertToNumber(faseBunga.mid_petals_fb_ba || '-'),
        late_petals: convertToNumber(faseBunga.late_petals_fb_ba || '-'),
        dry_petals: convertToNumber(faseBunga.dry_petals_fb_ba || '-'),
        filling_stage_1: convertToNumber(faseBunga.filling_stage_1_fb_ba || '-'),
        filling_stage_2: convertToNumber(faseBunga.filling_stage_2_fb_ba || '-'),
        sc0: convertToNumber(faseBunga.sc0_fb_ba || '-'),
        sc0_lebih: convertToNumber(faseBunga.sc0_ld_fb_ba || '-'),
        terpetik: convertToNumber(faseBunga.terpetik_fb_ba || '-'),
        dimakan_tikus: convertToNumber(faseBunga.dimakan_tikus_fb_ba || '-')
    };
};

// FUNGSI BARU: Mengambil data tanaman dari struktur Firebase
const getTanamanData = (plotData) => {
    const tanaman = plotData.data_entry?.tanaman || {};
    const penyakit = tanaman.penyakit_tanaman || {};
    return {
        normal: convertToNumber(tanaman.normal_t_ba || '-'),
        penyakit_phy: convertToNumber(penyakit.phy_pt_ba || '-'),
        penyakit_erw: convertToNumber(penyakit.erw_pt_ba || '-'),
        kerdil: convertToNumber(tanaman.kerdil_t_ba || '-')
    };
};

// FUNGSI BARU: Mengambil data buah alami dari struktur Firebase
const getBuahAlamiData = (plotData) => {
    const dataEntry = plotData.data_entry || {};
    return {
        buah_alami: convertToNumber(removeDecimal(dataEntry.buah_alami_ba) || '-'),
        mati: convertToNumber(dataEntry.mati_ba || '-'),
        total: convertToNumber(removeDecimal(dataEntry.total_ba) || '-'),
        spot_mati: convertToNumber(dataEntry.spot_mati_ba || '-')
    };
};

// FUNGSI BARU: Mengambil data tanaman pinggiran dari struktur Firebase
const getTanamanPinggiranData = (plotData) => {
    const tanamanPinggiran = plotData.data_entry?.tanaman_pinggiran || {};
    const penyakit = tanamanPinggiran.penyakit_tanaman_pinggiran || {};
    return {
        normal: convertToNumber(tanamanPinggiran.normal_tp_ba || '-'),
        penyakit_phy: convertToNumber(penyakit.phy_ptp_ba || '-'),
        penyakit_erw: convertToNumber(penyakit.erw_ptp_ba || '-'),
        kerdil: convertToNumber(tanamanPinggiran.kerdil_tp_ba || '-'),
        buah_alami_pinggiran: convertToNumber(tanamanPinggiran.buah_alami_tp_ba || '-'),
        dimakan_tikus_pinggiran: convertToNumber(tanamanPinggiran.dimakan_tikus_tp_ba || '-')
    };
};

// FUNGSI BARU: Mengambil data buah alami pinggiran dari struktur Firebase
const getBuahAlamiPinggiranData = (plotData) => {
    const tanamanPinggiran = plotData.data_entry?.tanaman_pinggiran || {};
    return {
        mati_pinggiran: convertToNumber(tanamanPinggiran.mati_tp_ba || '-'),
        total_pinggiran: convertToNumber(removeDecimal(tanamanPinggiran.total_tp_ba) || '-')
    };
};

// FUNGSI UTAMA: Membuat worksheet dengan format yang benar - PERBAIKAN TANGGAL 
const createWorksheetWithManualHeaders = (processedPlots) => {
    const headerKeys = getHeaderKeys();
    
    // Buat header rows secara manual
    const headerRows = createManualHeaderRows();
    
    // Konversi data plot ke array sesuai urutan header keys
    const dataRows = processedPlots.map(plot => {
        // Ambil data dengan format yang sama seperti di DataObservasiTab
        const faseBungaData = getFaseBungaData(plot);
        const tanamanData = getTanamanData(plot);
        const buahAlamiData = getBuahAlamiData(plot);
        const tanamanPinggiranData = getTanamanPinggiranData(plot);
        const buahAlamiPinggiranData = getBuahAlamiPinggiranData(plot);

        // Hitung populasi normal dan total
        const populasiNormal = calculatePopulation(tanamanData.normal, plot.pjp);
        const populasiTotal = calculatePopulation(buahAlamiData.total, plot.pjp);

        // Buat array untuk data row
        const dataRow = new Array(headerKeys.length).fill('');

        // Mapping data sesuai urutan header keys
        headerKeys.forEach((key, index) => {
            switch(key) {
                // Kolom utama A-M
                case 'Tanggal Pengamatan':
                    dataRow[index] = formatTanggalExcel(plot[key] || '');
                    break;
                case 'Tanggal Std Forcing':
                    dataRow[index] = formatTanggalExcel(plot[key] || '');
                    break;
                case 'Umur':
                    dataRow[index] = plot[key] || '';
                    break;
                case 'Lokasi':
                    dataRow[index] = plot[key] || '';
                    break;
                case 'Plot':
                    dataRow[index] = convertToNumber(plot.plot || '');
                    break;
                case 'Status':
                    dataRow[index] = plot[key] || '';
                    break;
                case 'Var':
                    dataRow[index] = plot[key] || '';
                    break;
                case 'Kls':
                    dataRow[index] = plot[key] || '';
                    break;
                case 'Jns':
                    dataRow[index] = plot[key] || '';
                    break;
                case 'Luas':
                    // PERBAIKAN: Simpan sebagai number untuk Excel, format display nanti di styling
                    dataRow[index] = plot[key] || '';
                    break;
                case 'Awal Rawat':
                    dataRow[index] = formatTanggalExcel(plot[key] || '');
                    break;
                case 'Pjp':
                    dataRow[index] = convertToNumber(plot[key] || '');
                    break;
                case 'jarak1':
                    dataRow[index] = '';
                    break;
                
                // Populasi
                case 'Populasi Normal':
                    dataRow[index] = convertToNumber(populasiNormal);
                    break;
                case 'Populasi Total':
                    dataRow[index] = convertToNumber(populasiTotal);
                    break;
                case 'jarak2':
                    dataRow[index] = '';
                    break;
                
                // Fase Bunga - SEMUA NUMBER
                case 'Open Heart':
                    dataRow[index] = faseBungaData.open_heart;
                    break;
                case 'Red Bud 125':
                    dataRow[index] = faseBungaData.red_bud_125;
                    break;
                case 'Red Bud 2.54':
                    dataRow[index] = faseBungaData.red_bud_254;
                    break;
                case 'Early Cones':
                    dataRow[index] = faseBungaData.early_cones;
                    break;
                case 'Mid Cones':
                    dataRow[index] = faseBungaData.mid_cones;
                    break;
                case 'Late Cones':
                    dataRow[index] = faseBungaData.late_cones;
                    break;
                case 'Early Petals':
                    dataRow[index] = faseBungaData.early_petals;
                    break;
                case 'Mid Petals':
                    dataRow[index] = faseBungaData.mid_petals;
                    break;
                case 'Late Petals':
                    dataRow[index] = faseBungaData.late_petals;
                    break;
                case 'Dry Petals':
                    dataRow[index] = faseBungaData.dry_petals;
                    break;
                case 'Filling Stage 1':
                    dataRow[index] = faseBungaData.filling_stage_1;
                    break;
                case 'Filling Stage 2':
                    dataRow[index] = faseBungaData.filling_stage_2;
                    break;
                case 'SC0':
                    dataRow[index] = faseBungaData.sc0;
                    break;
                case 'SC0 LD':
                    dataRow[index] = faseBungaData.sc0_lebih;
                    break;
                case 'Terpetik FB':
                    dataRow[index] = faseBungaData.terpetik;
                    break;
                case 'Dimakan Tikus FB':
                    dataRow[index] = faseBungaData.dimakan_tikus;
                    break;
                
                // Status Tanaman - SEMUA NUMBER
                case 'Normal':
                    dataRow[index] = tanamanData.normal;
                    break;
                case 'Phy':
                    dataRow[index] = tanamanData.penyakit_phy;
                    break;
                case 'Erw':
                    dataRow[index] = tanamanData.penyakit_erw;
                    break;
                case 'Kerdil':
                    dataRow[index] = tanamanData.kerdil;
                    break;
                
                // Buah Alami - SEMUA NUMBER
                case 'Buah Alami':
                    dataRow[index] = buahAlamiData.buah_alami;
                    break;
                case 'Mati':
                    dataRow[index] = buahAlamiData.mati;
                    break;
                case 'Total':
                    dataRow[index] = buahAlamiData.total;
                    break;
                case 'Spot Mati':
                    dataRow[index] = buahAlamiData.spot_mati;
                    break;
                
                // Tanaman Pinggiran - SEMUA NUMBER
                case 'Normal Pinggiran':
                    dataRow[index] = tanamanPinggiranData.normal;
                    break;
                case 'Phy Pinggiran':
                    dataRow[index] = tanamanPinggiranData.penyakit_phy;
                    break;
                case 'Erw Pinggiran':
                    dataRow[index] = tanamanPinggiranData.penyakit_erw;
                    break;
                case 'Kerdil Pinggiran':
                    dataRow[index] = tanamanPinggiranData.kerdil;
                    break;
                case 'Buah Alami Pinggiran':
                    dataRow[index] = tanamanPinggiranData.buah_alami_pinggiran;
                    break;
                
                // Buah Alami Pinggiran - SEMUA NUMBER
                case 'Mati Pinggiran':
                    dataRow[index] = buahAlamiPinggiranData.mati_pinggiran;
                    break;
                case 'Total Pinggiran':
                    dataRow[index] = buahAlamiPinggiranData.total_pinggiran;
                    break;
                
                default:
                    dataRow[index] = '';
            }
        });

        return dataRow;
    });
    
    // Gabungkan header dan data
    const worksheetData = [...headerRows, ...dataRows];
    
    // Buat worksheet
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
    
    // Set column widths
    const optimalWidths = calculateOptimalColumnWidths(worksheetData);
    ws['!cols'] = optimalWidths;
    
    // Set merge config
    ws['!merges'] = getMergeConfig();
    
    // TERAPKAN FORMAT TANGGAL DAN NUMBER SECARA MANUAL
    const range = XLSX.utils.decode_range(ws['!ref']);
    
    // Format untuk setiap sel
    for (let row = 3; row < worksheetData.length; row++) {
        // Kolom A: Tanggal Pengamatan
        const cellAddressA = XLSX.utils.encode_cell({ r: row, c: 0 });
        if (ws[cellAddressA] && ws[cellAddressA].v !== '-' && ws[cellAddressA].v !== '') {
            // Set format number untuk tanggal
            ws[cellAddressA].z = 'dd/mm/yyyy';
            
            // Konversi string ke Excel serial number untuk sorting - TANPA WAKTU
            if (typeof ws[cellAddressA].v === 'string') {
                const dateStr = ws[cellAddressA].v;
                const [day, month, year] = dateStr.split('/');
                if (day && month && year) {
                    // GUNAKAN Date.UTC UNTUK MENGHINDARI TIMEZONE ISSUE
                    const date = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)));
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const diffDays = (date - excelEpoch) / (1000 * 60 * 60 * 24);
                    
                    ws[cellAddressA].v = diffDays;
                    ws[cellAddressA].t = 'n';
                }
            }
        }

        // Kolom B: Tanggal Std Forcing
        const cellAddressB = XLSX.utils.encode_cell({ r: row, c: 1 });
        if (ws[cellAddressB] && ws[cellAddressB].v !== '-' && ws[cellAddressB].v !== '') {
            // Set format number untuk tanggal
            ws[cellAddressB].z = 'dd/mm/yyyy';
            
            // Konversi string ke Excel serial number untuk sorting - TANPA WAKTU
            if (typeof ws[cellAddressB].v === 'string') {
                const dateStr = ws[cellAddressB].v;
                const [day, month, year] = dateStr.split('/');
                if (day && month && year) {
                    const date = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)));
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const diffDays = (date - excelEpoch) / (1000 * 60 * 60 * 24);
                    
                    ws[cellAddressB].v = diffDays;
                    ws[cellAddressB].t = 'n';
                }
            }
        }

        // Kolom K: Awal Rawat
        const cellAddressK = XLSX.utils.encode_cell({ r: row, c: 10 });
        if (ws[cellAddressK] && ws[cellAddressK].v !== '-' && ws[cellAddressK].v !== '') {
            // Set format number untuk tanggal
            ws[cellAddressK].z = 'dd/mm/yyyy';
            
            // Konversi string ke Excel serial number untuk sorting - TANPA WAKTU
            if (typeof ws[cellAddressK].v === 'string') {
                const dateStr = ws[cellAddressK].v;
                const [day, month, year] = dateStr.split('/');
                if (day && month && year) {
                    const date = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)));
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const diffDays = (date - excelEpoch) / (1000 * 60 * 60 * 24);
                    
                    ws[cellAddressK].v = diffDays;
                    ws[cellAddressK].t = 'n';
                }
            }
        }
    }

    // PERBAIKAN: Format khusus untuk kolom J (Luas) - dengan format Indonesia (koma sebagai desimal)
for (let row = 3; row < worksheetData.length; row++) {
    const cellAddressJ = XLSX.utils.encode_cell({ r: row, c: 9 });
    if (ws[cellAddressJ] && ws[cellAddressJ].v !== null && ws[cellAddressJ].v !== undefined) {
        // Tetap simpan sebagai number untuk perhitungan Excel
        ws[cellAddressJ].t = 'n';
        // Format dengan 2 digit desimal TANPA mengubah titik/koma
        ws[cellAddressJ].z = '0.00';
    }
}

    // Format integer untuk kolom E, L, dan N sampai akhir (Plot, Pjp, Populasi sampai Pinggiran Total)
    for (let row = 3; row < worksheetData.length; row++) {
        // Kolom E: Plot
        const cellAddressE = XLSX.utils.encode_cell({ r: row, c: 4 });
        if (ws[cellAddressE] && ws[cellAddressE].v !== null && ws[cellAddressE].v !== undefined) {
            ws[cellAddressE].t = 'n';
            ws[cellAddressE].z = '0'; // Format tanpa digit desimal
        }

        // Kolom L: Pjp
        const cellAddressL = XLSX.utils.encode_cell({ r: row, c: 11 });
        if (ws[cellAddressL] && ws[cellAddressL].v !== null && ws[cellAddressL].v !== undefined) {
            ws[cellAddressL].t = 'n';
            ws[cellAddressL].z = '0'; // Format tanpa digit desimal
        }
        
        // Kolom N sampai akhir (13 sampai akhir) - semua data numerik
        const integerColumns = [];
        for (let col = 13; col <= range.e.c; col++) {
            integerColumns.push(col);
        }
        
        integerColumns.forEach(col => {
            const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
            if (ws[cellAddress] && ws[cellAddress].v !== null && ws[cellAddress].v !== undefined) {
                ws[cellAddress].t = 'n';
                ws[cellAddress].z = '0'; // Format tanpa digit desimal
            }
        });
    }
    
    return ws;
};

const convertToExcelDate = (dateString) => {
  if (!dateString || dateString === '-') return null;
  
  try {
    const [day, month, year] = dateString.split('-');
    if (day && month && year) {
      // Buat objek Date dengan waktu 12:00:00 untuk menghindari masalah timezone
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 12, 0, 0);
      
      // Validasi apakah date valid
      if (isNaN(date.getTime())) return null;
      
      // Konversi ke Excel serial number YANG BENAR
      // Excel menggunakan 30 Des 1899 sebagai basis, bukan 1 Jan 1900
      const excelEpoch = new Date(1899, 11, 30); // 30 Desember 1899
      const diffTime = date - excelEpoch;
      const diffDays = diffTime / (1000 * 60 * 60 * 24);
      
      return diffDays;
    }
  } catch (error) {
    console.error('Error converting date:', error);
  }
  return null;
};

// MODIFIKASI pada fungsi handleDownloadExcel - PERBAIKAN FILENAME DAN JARAK2
export const handleDownloadExcel = async (selectedItems, orders, onStatusUpdate, onMenuClose) => {
    if (selectedItems.length === 0) {
        onStatusUpdate({
            open: true,
            message: "Pilih setidaknya satu data untuk di-download",
            severity: "warning"
        });
        return;
    }

    try {
        // Filter data yang dipilih
        const selectedData = orders.filter(order => selectedItems.includes(order.id));
        
        // Array untuk menyimpan semua data plot yang processed
        let allProcessedPlots = [];

        // Ambil lokasi pertama untuk nama file
        let lokasiFileName = '';
        let tanggalPengamatanFileName = '';

        // Ambil data detail untuk setiap pengamatanKey yang dipilih
        for (const order of selectedData) {
            if (order.pengamatanKey) {
                try {
                    const pengamatanRef = ref(database, `db_freshpine/db_pengamatan/buah_alami/${order.pengamatanKey}`);
                    const snapshot = await get(pengamatanRef);
                    
                    if (snapshot.exists()) {
                        const pengamatanData = snapshot.val();
                        
                        // Ambil data lokasi untuk mendapatkan info bibit dan awal rawat
                        let lokasiData = null;
                        if (order.id_lokasi) {
                            const lokasiRef = ref(database, `db_freshpine/tb_lokasi`);
                            const lokasiSnapshot = await get(lokasiRef);
                            if (lokasiSnapshot.exists()) {
                                lokasiSnapshot.forEach((childSnapshot) => {
                                    const lokasiItem = childSnapshot.val();
                                    if (lokasiItem.id_lokasi === order.id_lokasi) {
                                        lokasiData = lokasiItem;
                                    }
                                });
                            }
                        }

                        // Proses data bibit
                        const bibitData = processBibitData(lokasiData?.bibit);
                        const formattedAwalRawat = formatDateToDDMMYYYY(lokasiData?.mulai_rawat);
                        const tanggalStdForcing = calculateTanggalStdForcing(lokasiData?.mulai_rawat, bibitData.kelas);

                        // Set lokasi untuk nama file (gunakan yang pertama ditemukan)
                        if (!lokasiFileName && order.lokasi) {
                            lokasiFileName = order.lokasi;
                        }
                        if (!tanggalPengamatanFileName && order.tanggal_pengamatan) {
                            tanggalPengamatanFileName = formatDateToDDMMYYYY(order.tanggal_pengamatan);
                        }

                        // Cek jika ada plot data
                        if (pengamatanData.plot) {
                            Object.entries(pengamatanData.plot).forEach(([plotKey, plotData]) => {
                                if (plotData.status_pengamatan_per_plot === "Processed") {
                                    // BUAT OBJEK PLOT DENGAN DATA YANG DIPERLUKAN
                                    const plotRow = {
                                        // Data utama
                                        'Tanggal Pengamatan': formatDateToDDMMYYYY(order.tanggal_pengamatan) || '',
                                        'Tanggal Std Forcing': tanggalStdForcing,
                                        'Umur': order.fmp || '',
                                        'Lokasi': order.lokasi || '',
                                        'Plot': plotData.plot || '',
                                        'Status': lokasiData?.status || '',
                                        'Var': bibitData.varietas,
                                        'Kls': bibitData.kelas,
                                        'Jns': bibitData.jenis,
                                        'Luas': plotData.luas_plot || '',
                                        'Awal Rawat': formattedAwalRawat,
                                        'Pjp': plotData.pjp || '',
                                        // Simpan data plot lengkap untuk digunakan oleh fungsi getter
                                        ...plotData
                                    };
                                    
                                    allProcessedPlots.push(plotRow);
                                }
                            });
                        }
                    }
                } catch (error) {
                    console.error(`Error fetching data for ${order.pengamatanKey}:`, error);
                }
            }
        }

        // Jika tidak ada plot processed yang ditemukan
        if (allProcessedPlots.length === 0) {
            onStatusUpdate({
                open: true,
                message: "Tidak ada data plot dengan status 'Processed' yang ditemukan",
                severity: "warning"
            });
            return;
        }

        // Buat workbook dan worksheet dengan header manual
        const wb = XLSX.utils.book_new();
        const ws = createWorksheetWithManualHeaders(allProcessedPlots);

        // Tambahkan worksheet ke workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Data Plot Processed');

        // PERBAIKAN: Format fileName sesuai permintaan
        const fileName = `Peng. Buah Alami - ${lokasiFileName || 'Data'} - ${tanggalPengamatanFileName || new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(wb, fileName);

        // Hitung statistik
        const uniquePengamatanKeys = [...new Set(allProcessedPlots.map(plot => plot['Lokasi']))];
        
        onStatusUpdate({
            open: true,
            message: `Berhasil mendownload ${allProcessedPlots.length} plot processed dari ${uniquePengamatanKeys.length} lokasi`,
            severity: "success"
        });

        onMenuClose();
    } catch (error) {
        console.error('Error downloading Excel:', error);
        onStatusUpdate({
            open: true,
            message: "Gagal mendownload data: " + error.message,
            severity: "error"
        });
    }
};